import { render, staticRenderFns } from "./GuestsCard.vue?vue&type=template&id=177436c8&"
import script from "./GuestsCard.vue?vue&type=script&lang=js&"
export * from "./GuestsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports